import {createStyles, makeStyles} from '@material-ui/core/styles';
import React from 'react';

import {EeButton} from 'components/EeButton/EeButton';
import {EeModal} from 'components/EeModal/EeModal';

import {SectionType, SettingsType, SettingsMap} from '../../../../dashboardSettingsTypes';
import {SettingsRow} from './components/SettingsRow';
import './styles.scss';

const useStyles = makeStyles(() =>
  createStyles({
    scrollBody: {
      overflowY: 'scroll',
    },
  }),
);

export const Settings = (
  {
    close,
    confirmText,
    defaultDashboardSettings,
    description,
    dashboardSettings,
    isOpen,
    saveDashboardSettings,
    settingsMap,
    submitText,
  }:
    {
      close: CallableFunction
      confirmText: React.ReactNode
      defaultDashboardSettings: SettingsType
      description: React.ReactNode
      dashboardSettings: SettingsType
      isOpen: boolean
      saveDashboardSettings: CallableFunction
      settingsMap: SettingsMap
      submitText: string
    }
) => {
  const classes = useStyles();
  const [confirmationIsOpen, setConfirmationIsOpen] = React.useState(false);
  const [cancelIsOpen, setCancelIsOpen] = React.useState(false);
  const [touched, setTouched] = React.useState(false);
  const [localDashboardSettings, setLocalDashboardSettings] = React.useState<SettingsType>();

  React.useEffect(() => {
    if (dashboardSettings && dashboardSettings.sections.length > 0) {
      setLocalDashboardSettings(dashboardSettings);
    }
  }, [dashboardSettings]);

  function closeSettings() {
    setConfirmationIsOpen(false);
    close();
  }

  function closeCancelAndSettings() {
    setCancelIsOpen(false);
    closeSettings();
    setTouched(false);
  }

  function setLocalSettings(sectionName: string, sectionData: SectionType) {
    setTouched(true);
    if (!localDashboardSettings) return
    let tempSettings = {...localDashboardSettings};
    const sectionIndex = tempSettings.sections.findIndex(s => s.name === sectionName);
    tempSettings.sections[sectionIndex] = sectionData;
    tempSettings.sections = tempSettings.sections.sort((a, b) => a.order - b.order);
    setLocalDashboardSettings(tempSettings);
  }

  function saveLocalChanges() {
    saveDashboardSettings(localDashboardSettings).then(() => {
      closeSettings();
      setTouched(false);
    });
  }

  function resetDashboardSettings() {
    setLocalDashboardSettings(defaultDashboardSettings);
    setTouched(true);
  }

  return (
    <>
      <EeModal
        classes={{
          scrollBody: classes.scrollBody,
        }}
        width="sm"
        open={isOpen}
        scroll="body"
        className="settings-modal"
        title={
          <div className="d-flex w-100 justify-content-between">
            <div>
              <span className="d-flex align-items-center">Manage Content</span>
            </div>
            <div className="mr-2">
              <EeButton
                color="secondary"
                variant="contained"
                label="RESET"
                onClick={() => resetDashboardSettings()}
              />
            </div>
          </div>
        }
        submitTitle={submitText}
        onClose={() => (touched ? setCancelIsOpen(true) : closeSettings())}
        onSubmit={() => setConfirmationIsOpen(true)}
      >
        <span className="d-flex my-4" style={{ color: '#1e1e1e' }}>
          {description}
        </span>
        {localDashboardSettings &&
          localDashboardSettings.sections.map(
            (section, i) =>
              settingsMap[section.name] && (
                <SettingsRow
                  key={i}
                  initialSection={section}
                  sectionMap={settingsMap[section.name]}
                  updateSection={setLocalSettings}
                />
              ),
          )}
      </EeModal>
      <EeModal
        width="xs"
        open={confirmationIsOpen}
        className="confirm-modal"
        title="Are you sure ? "
        submitTitle="APPLY"
        onClose={() => setConfirmationIsOpen(false)}
        onSubmit={() => saveLocalChanges()}
      >
        <span className="d-flex my-4" style={{ color: '#1e1e1e' }}>
          {confirmText}
        </span>
      </EeModal>
      <EeModal
        width="xs"
        open={cancelIsOpen}
        title="Are you sure ? "
        submitTitle="Exit without saving"
        onClose={() => setCancelIsOpen(false)}
        onSubmit={closeCancelAndSettings}
      >
        <span>Do you want to cancel your changes ? </span>
      </EeModal>
    </>
  );
};
